import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DetailedTicketSource } from '@sb-tools/typescript/enums/detailed-ticket-source.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'detailedTicketSource' })
export class DetailedTicketSourcePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(ticketSource: DetailedTicketSource, isAdTicket = false): string {
        let ticketSourceName;

        switch (ticketSource) {
            case DetailedTicketSource.formExternal:
                ticketSourceName = this.translateService.instant('External form');
                break;
            case DetailedTicketSource.formInternal:
                ticketSourceName = this.translateService.instant('Internal form');
                break;
            case DetailedTicketSource.formForward:
                ticketSourceName = this.translateService.instant('Forward form');
                break;

            case DetailedTicketSource.facebookPost:
                ticketSourceName = this.translateService.instant('Facebook post');
                break;
            case DetailedTicketSource.facebookImage:
                ticketSourceName = this.translateService.instant('Facebook image');
                break;
            case DetailedTicketSource.facebookMention:
                ticketSourceName = this.translateService.instant('Facebook mention');
                break;
            case DetailedTicketSource.facebookPrivateMessage:
                ticketSourceName = this.translateService.instant('Facebook private message');
                break;
            case DetailedTicketSource.facebookReview:
                ticketSourceName = this.translateService.instant('Facebook review');
                break;
            case DetailedTicketSource.facebookEvent:
                ticketSourceName = this.translateService.instant('Facebook event');
                break;
            case DetailedTicketSource.facebookVideo:
                ticketSourceName = this.translateService.instant('Facebook video');
                break;
            case DetailedTicketSource.facebookShare:
                ticketSourceName = this.translateService.instant('Facebook share');
                break;
            case DetailedTicketSource.facebookDnbBot:
                ticketSourceName = this.translateService.instant('Facebook Messenger ▶ DNB Bot');
                break;
            case DetailedTicketSource.facebookGroup:
                ticketSourceName = this.translateService.instant('Facebook group');
                break;

            case DetailedTicketSource.instagramTag:
                ticketSourceName = this.translateService.instant('Instagram tag');
                break;
            case DetailedTicketSource.instagramAccount:
                ticketSourceName = this.translateService.instant('Instagram account');
                break;
            case DetailedTicketSource.instagramMention:
                ticketSourceName = this.translateService.instant('Instagram mention');
                break;
            case DetailedTicketSource.instagramPhotoTag:
                ticketSourceName = this.translateService.instant('Instagram photo tag');
                break;
            case DetailedTicketSource.instagramDirectMessage:
                ticketSourceName = this.translateService.instant('Instagram direct message');
                break;

            case DetailedTicketSource.email:
                ticketSourceName = this.translateService.instant('Email');
                break;
            case DetailedTicketSource.emailOutlookPlugin:
                ticketSourceName = this.translateService.instant('Email Outlook add-in');
                break;

            case DetailedTicketSource.chat:
                ticketSourceName = this.translateService.instant('Chat');
                break;

            case DetailedTicketSource.chatPublicAPI:
                ticketSourceName = this.translateService.instant('Chat (external)');
                break;

            case DetailedTicketSource.youtubeVideoComment:
                ticketSourceName = this.translateService.instant('YouTube video comment');
                break;
            case DetailedTicketSource.youtubeDiscussion:
                ticketSourceName = this.translateService.instant('YouTube discussion');
                break;

            case DetailedTicketSource.googleMyBusinessLocationQuestion:
                ticketSourceName = this.translateService.instant('Google Questions');
                break;
            case DetailedTicketSource.googleMyBusinessLocationReview:
                ticketSourceName = this.translateService.instant('Google Reviews');
                break;

            case DetailedTicketSource.trustpilotServiceReview:
                ticketSourceName = this.translateService.instant('Trustpilot reviews');
                break;

            case DetailedTicketSource.googlePlayMarketReview:
                ticketSourceName = this.translateService.instant('Google Play reviews');
                break;

            case DetailedTicketSource.appStoreReview:
                ticketSourceName = this.translateService.instant('App Store reviews');
                break;

            case DetailedTicketSource.whatsAppConversation:
                ticketSourceName = this.translateService.instant('WhatsApp');
                break;

            case DetailedTicketSource.tikTokVideo:
                ticketSourceName = this.translateService.instant('TikTok video');
                break;

            case DetailedTicketSource.api:
                ticketSourceName = this.translateService.instant('API');
                break;

            default:
                ticketSourceName = this.translateService.instant('Unknown detailed source');
                break;
        }

        if (isAdTicket) {
            ticketSourceName += ` (${this.translateService.instant('Marketing')})`;
        }

        return ticketSourceName;
    }
}
